<section id="viewerContainer" class="viewer-container">
  <zbp-loading-placeholder *ngIf="shouldDisplayLoader$ | async"></zbp-loading-placeholder>

  <ng-container *ngIf="viewerAsset$ | async as asset">
    <ng-container *ngIf="asset.assetId">
      <main id="viewer" class="viewer-component material-viewer-background">
        <div class="viewer-wrapper">
          <!-- Desktop: controls render before the header/asset so the controls are tabbed into first (controls sit on left side). -->
          @if (isDesktop) {
            <ng-container *ngTemplateOutlet="viewerControls"></ng-container>
          }

          <div class="asset-header-wrapper">
              <header id="viewerHeader" class="viewerHeader w-100 d-flex flex-nowrap m-0">
                <!-- Student doesn't need this as they already have a header. -->
                @if(!isInsideIframe) {
                  <div class="mobile-logo-wrapper">
                    @if (!isZBPortal) {
                      <img class="appLogo"
                            src="assets/img/highlights.svg"
                            alt="highlights logo"
                            role="presentation"
                      />
                    } @else {
                      <img class="appLogo"
                            src="assets/img/zb-icon-white.svg"
                            alt="zb logo"
                            role="presentation"
                      />
                    }
                  </div>
                }
                <h1 class="h6 viewer-header-title" data-cy="viewer-header-title" [innerHTML]="asset.category + ' - ' + asset.name"></h1>
                @if(hasTopicKey$ | async; as hasTopicKey) {
                  @if(toggleAssets$ | async; as toggleAssets) {
                    @if(toggleAssets.length > 0) {
                      <div class="viewerHeaderToggleContainer" ngbDropdown [autoClose]="'inside'" #toggleDropdown="ngbDropdown">
                        <button *ngIf="hasTopicKey" id="toggleDropdownButton" class="btn btn-sm" ngbDropdownToggle [innerHTML]="asset.name"></button>
                        <div aria-labelledby="toggleDropdownButton" ngbDropdownMenu>
                          <ng-container *ngFor="let toggleAsset of toggleAssets; index as i">
                            <button id="toggleAssetButton{{i}}" type="button" class="btn btn-sm assetToggleButton" ngbDropdownItem
                              (click)="handleToggledAsset(toggleAsset.assetId)" [innerHTML]="renderText(toggleAsset.name)"></button>
                          </ng-container>
                        </div>
                      </div>
                    }
                  }
                }
                <!-- On mobile, back button is in the header. CSS controls the show/hide.-->
                <zbp-viewer-back-button
                  id="viewer-back-button-mobile"
                  [isInsideIframe]="isInsideIframe"
                  [isActivityComplete]="isActivityComplete">
                </zbp-viewer-back-button>
              </header>
              <div *ngIf="{series: series$ | async, grade: grade$ | async} as apipe" class="viewerAssetWrapper">

              @if(messages$ | async; as messages) {
                @if(messages.length) {
                  <aside  id="viewerAlert" role="alert" class="alert w-75 mx-auto my-1 text-center"
                    [class.alert-danger]="messages?.length">
                    <ul id="viewerAlertList" *ngFor="let message of messages">
                      <li>{{ message }}</li>
                    </ul>
                  </aside>
                  }
              }

              <ng-container [ngSwitch]="asset.viewerAssetType">
                <zbp-viewer-audio *ngSwitchCase="'Audio'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade" [viewerAssets]="assetList"
                  (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-audio>
                <zbp-viewer-canvas *ngSwitchCase="'Canvas'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                  (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"
                                   [zoomLevel]="zoomPercent"
                                   [selectedTool]="activeTool"
                                   [clearClicked]="clearClicked$"
                                   [drawingColor]="drawingColor"
                                   [brushSize]="brushSize"
                ></zbp-viewer-canvas>
                <zbp-viewer-canvas
                  *ngSwitchCase="'Image'"
                  [asset]="asset"
                  [series]="apipe.series"
                  [grade]="apipe.grade"
                  (loaded)="shouldDisplayLoader$.next(false); onImageLoaded()"
                  (withError)="handleError($event)"
                  [zoomLevel]="zoomPercent"
                  [selectedTool]="activeTool"
                  [drawingColor]="drawingColor"
                  [brushSize]="brushSize"
                  [clearClicked]="clearClicked$"
                />
                <zbp-viewer-document *ngSwitchCase="'Pdf'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                  (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"
                                    [zoomLevel]="zoomPercent"
                                    [locked]="false"></zbp-viewer-document>
                <zbp-viewer-document *ngSwitchCase="'PdfLocked'" [asset]="asset" [series]="apipe.series"
                                            [grade]="apipe.grade" (loaded)="shouldDisplayLoader$.next(false)"
                                            (withError)="handleError($event)"
                                            [zoomLevel]="zoomPercent"
                                            [locked]="true"></zbp-viewer-document>
                <zbp-viewer-iframe *ngSwitchCase="'Ilb'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                  (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-iframe>
                <zbp-viewer-iframe *ngSwitchCase="'Iwb'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                  (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-iframe>
                <zbp-viewer-iframe
                  *ngSwitchCase="'SuperSmart'"
                  [asset]="asset"
                  [series]="apipe.series"
                  [grade]="apipe.grade"
                  (loaded)="shouldDisplayLoader$.next(false); onSuperSmartLoaded();"
                  (withError)="handleError($event)"
                />
                <zbp-viewer-print-canvas *ngSwitchCase="'ImagePrint'" [asset]="asset" [series]="apipe.series"
                                        [grade]="apipe.grade"
                                        (loaded)="shouldDisplayLoader$.next(false)"
                                        (withError)="handleError($event)"
                                        [zoomLevel]="zoomPercent"
                                        [clearClicked]="clearClicked$"
                                        [selectedTool]="activeTool"
                                        [drawingColor]="drawingColor"
                                        [brushSize]="brushSize"
                                        [triggerPrint]="triggerPrint"
                                        (isPrinting)="triggerPrint = $event.valueOf()"
                ></zbp-viewer-print-canvas>
                <zbp-viewer-video
                  *ngSwitchCase="'Video'"
                  [asset]="asset"
                  (loaded)="shouldDisplayLoader$.next(false)"
                  (withError)="handleError($event)"
                  [zoomLevel]="zoomPercent"
                  (completed)="onVideoCompleted()"
                />
                <zbp-viewer-video-canvas *ngSwitchCase="'VideoCanvas'" [asset]="asset" [series]="apipe.series"
                                        [grade]="apipe.grade"
                                        [selectedTool]="activeTool"
                                        [drawingColor]="drawingColor"
                                        [brushSize]="brushSize"
                                        [clearClicked]="clearClicked$"
                                        (loaded)="shouldDisplayLoader$.next(false)"
                                        (withError)="handleError($event)"></zbp-viewer-video-canvas>
              </ng-container>
            </div>
            </div>

          <!-- Mobile: controls render after the header/asset so the header is tabbed into first (controls sit at the bottom). -->
          @if (!isDesktop) {
            <ng-container *ngTemplateOutlet="viewerControls"></ng-container>
          }

          <!-- Template is for the controls. Rendered in different locations depending on screen size. -->
          <ng-template #viewerControls>
            @if ((viewerConfig$ | async) || isStudent) {
              <div class="viewer-controls">
                <zbp-viewer-controls
                  [viewerConfiguration]="viewerConfiguration"
                  [asset]="asset"
                  [viewerAssets]="assetList"
                  [isInsideIframe]="isInsideIframe"
                  [isActivityComplete]="isActivityComplete"
                  (activeTool)="setActiveTool($event)"
                  (zoomPercent)="setZoomPercent($event)"
                  (triggerPrint)="printImage()"
                  (clearDrawing)="clear()"
                  (activeColor)="setDrawingColor($event)"
                  (activeSize)="setBrushSize($event)"
                  [isDesktop]="isDesktop"
                  [isLessonNavigation]="isLessonNavigation"
                  [lessonSteps]="lessonSteps$ | async"
                >
                </zbp-viewer-controls>
              </div>
            }
          </ng-template>
      </div>
    </main>
  </ng-container>
</ng-container>

</section>
